// Login.js
import React, { useState } from 'react';
import {
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  signInWithPopup,
} from 'firebase/auth';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import './Auth.css';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  /* ────────────────────────── HANDLERS ────────────────────────── */

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const { user } = await signInWithEmailAndPassword(auth, email, password);

      const userDocRef = doc(db, 'users', user.uid);
      const snap = await getDoc(userDocRef);

      if (snap.exists()) {
        const data = snap.data();
        if (!data.API_KEY) {
          navigate('/solicitar-acceso');
        } else {
          localStorage.setItem('API_KEY', data.API_KEY);
          navigate('/messages');
        }
      } else {
        throw new Error('El documento del usuario no existe.');
      }
    } catch (err) {
      if (
        err.code === 'auth/user-not-found' ||
        err.code === 'auth/wrong-password' ||
        err.code === 'auth/invalid-credential'
      ) {
        setError('Error: El correo electrónico o la contraseña son incorrectos.');
      } else {
        setError('Error al iniciar sesión: ' + err.message);
      }
    }
  };

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const { user } = await signInWithPopup(auth, provider);

      const userDocRef = doc(db, 'users', user.uid);
      const snap = await getDoc(userDocRef);

      if (snap.exists()) {
        const data = snap.data();
        if (!data.API_KEY) {
          navigate('/solicitar-acceso');
        } else {
          localStorage.setItem('API_KEY', data.API_KEY);
          navigate('/messages');
        }
      } else {
        setError(
          'Error: El usuario no está registrado. Por favor, regístrate primero.'
        );
      }
    } catch (err) {
      setError('Error al iniciar sesión con Google: ' + err.message);
    }
  };

  /* ──────────────────────────── RENDER ─────────────────────────── */

  return (
    <div className="auth-page">
      {/* ▸ wrapper que centra vertical y horizontalmente */}
      <div className="auth-wrapper">
        <div className="auth-container">
          <h2>Iniciar Sesión</h2>

          <form className="auth-form" onSubmit={handleLogin}>
                <label htmlFor="email" className="auth-label">
                  Email<span className="required">*</span>
                </label>
                <input
                  id="email"
                  className="auth-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Ingresa tu correo electrónico"
                  required
                />

                {/* contraseña con “ojo” */}
                <div className="password-field">
                  <label htmlFor="password" className="auth-label">
                    Contraseña<span className="required">*</span>
                  </label>

                  <input
                    id="password"
                    className="auth-input"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Ingresa tu contraseña"
                    required
                  />

                  <FontAwesomeIcon
                    icon={showPassword ? faEyeSlash : faEye}
                    className="toggle-password"
                    onClick={() => setShowPassword(!showPassword)}
                    title={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                  />
                </div>

                <button type="submit" className="auth-button">
                  Ingresar
                </button>
              </form>

              <p>
                <Link className="a" to="/reset-password">
                  Olvidé mi contraseña
                </Link>
              </p>

              <p className="auth-text">
                ¿No tienes una cuenta?{' '}
                <Link className="a" to="/register">
                  Regístrate
                </Link>
              </p>

          {error && <p className="error">{error}</p>}
        </div>
      </div>
    </div>
  );
};

export default Login;
